export const FeatureUnboxingEmbedderMessages = {
  CloseIframe: 'CLOSE_IFRAME',
  FullscreenIframe: 'FULLSCREEN_IFRAME',
  ParentLoaded: 'PARENT_LOADED',
  RedirectTo: 'REDIRECT_TO'
};